export default Object.freeze({
  CNAME: 'SSL証明書 更新状況一覧',
  CURL: 'https://ssl-check.ketoha.xyz/',
});
